import { ENTITY_NAMES } from "../entityTypes/entityTypes";

export const ISSUE_TEMPLATE_TABS = {
  DETAILS: "details",
  ORDER_TEMPLATES: "order_templates",
};

export const ISSUE_TEMPLATE_TABS_LIST = [
  {
    name: ISSUE_TEMPLATE_TABS.DETAILS,
    value: ISSUE_TEMPLATE_TABS.DETAILS,
    label: "Details",
  },
  {
    name: ISSUE_TEMPLATE_TABS.ORDER_TEMPLATES,
    value: ISSUE_TEMPLATE_TABS.ORDER_TEMPLATES,
    label: ENTITY_NAMES.ORDER_TEMPLATES,
  },
];
